var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tw-bg-white tw-px-4 tw-rounded-t"},[_c('div',{staticClass:"tw-py-3 tw-w-full tw-border-b tw-border-b-1 tw-border-grey-300 tw-border-b-solid c-header",class:_vm.slotWrapperClass},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }